type Props = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

export default function AnimauxIcon({ className, ...props }: Props) {
  return (
    <svg
      width="28px"
      height="29px"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={className}
    >
      <path
        d="M13.4727 7.3044C13.4727 9.51571 12.2142 11.3083 10.6618 11.3083C9.10969 11.3083 7.85123 9.51571 7.85123 7.3044C7.85123 5.09308 9.10969 3.30047 10.6618 3.30047C12.2142 3.30047 13.4727 5.09308 13.4727 7.3044Z"
        fill="currentColor"
      />
      <path
        d="M7.67163 13.0043C7.67163 14.9071 6.58885 16.4495 5.25305 16.4495C3.91749 16.4495 2.83447 14.9072 2.83447 13.0043C2.83447 11.1016 3.91743 9.55925 5.25305 9.55925C6.58885 9.55925 7.67163 11.1016 7.67163 13.0043Z"
        fill="currentColor"
      />
      <path
        d="M23.8396 22.8212C23.8396 26.1101 21.4512 25.8584 18.0223 25.4967C16.7943 25.3673 15.4327 25.2238 13.9997 25.2238C12.5667 25.2238 11.2052 25.3673 9.97715 25.4967C6.54829 25.8584 4.1601 26.1101 4.1601 22.8212C4.1601 20.5956 5.20358 19.3993 7.83151 16.7714C7.96329 16.624 8.0946 16.4756 8.22568 16.3275C9.86499 14.4755 11.4751 12.6565 13.9997 12.6565C16.62 12.6565 18.3667 14.6155 20.0806 16.5378C20.15 16.6158 20.2196 16.6939 20.289 16.7714C23.148 19.6304 23.8396 20.5957 23.8396 22.8212Z"
        fill="currentColor"
      />
      <path
        d="M22.7468 16.4495C24.0826 16.4495 25.1653 14.9072 25.1653 13.0043C25.1653 11.1016 24.0826 9.55925 22.7468 9.55925C21.411 9.55925 20.3282 11.1016 20.3282 13.0043C20.3282 14.9071 21.411 16.4495 22.7468 16.4495Z"
        fill="currentColor"
      />
      <path
        d="M17.3383 11.3078C18.8907 11.3078 20.1492 9.51524 20.1492 7.30392C20.1492 5.0926 18.8907 3.29999 17.3383 3.29999C15.7859 3.29999 14.5275 5.0926 14.5275 7.30392C14.5275 9.51524 15.7859 11.3078 17.3383 11.3078Z"
        fill="currentColor"
      />
    </svg>
  );
}
